import { SHALLOW_CONFIG } from './constants';
/** Maps storage needs to keywords that can be used to search for designs with specific properties.
 * These keywords are used in kind of a free text search in the data set.
 */
export const getTagsForStorageNeed = (need, params) => {
    // For shallow depth, there is no way to search for jewellery inserts directly.
    // Pull out trays are considered as jewellery storage for these.
    const jewelleryKeywords = params.depth === SHALLOW_CONFIG ? ['pull-out tray'] : ['jewellery'];
    const mapping = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '': [],
        folding: ['shelf', 'drawer'],
        hanging: ['clothes rail'],
        shoes: ['shoe'],
        jewellery: jewelleryKeywords,
        bags: ['shelf'],
        underwear: ['drawer', 'basket'],
        trousers: ['trouser']
    };
    return mapping[need];
};
//# sourceMappingURL=storageNeedsHelper.js.map